export const pluralizer = (count: number, word: string, suffix = 's') =>
  `${word}${count !== 1 ? suffix : ''}`;
